import React from 'react'
import MessageBubble, { MessageBubbleProps } from '../MessageBubble'
import styles from './styles.css'

export interface MessageBubbleTextProps extends MessageBubbleProps {
  children: React.ReactNode
}

class MessageBubbleText extends React.Component<MessageBubbleTextProps> {
  public render() {
    const { children, ...rest } = this.props
    return (
      <MessageBubble className={styles.textMessageBubble} {...rest}>
        {children}
      </MessageBubble>
    )
  }
}

export default MessageBubbleText
